import React from 'react';

const InsuranceTermsText: React.FC = (): JSX.Element => (
    <div className="l-article">
        <h2>1. CONTRATAÇÃO FACULTATIVA</h2>
        <p>
            1.1. A contratação do seguro é realizada de forma facultativa, por livre e espontânea manifestação do proponente e passível de cancelamento pelo segurado.
        </p>

        <h2>2. EXCLUSIVIDADE</h2>
        <p>
            2.1. O Intermediário possui vínculo de exclusividade com a Seguradora para a oferta do Seguro objeto desta contratação.
        </p>

        <h2>3. DISPONIBILIDADE DAS CONDIÇÕES CONTRATUAIS</h2>
        <p>
            3.1. As condições contratuais do produto Seguro foram disponibilizadas de forma prévia ao proponente, conforme exigido pelas regulamentações aplicáveis. As Condições Contratuais do produto estão disponíveis e podem ser consultadas a qualquer momento no site <a href="https://www.susep.gov.br" target="_blank">www.susep.gov.br</a>.
        </p>
        <p>
            O Segurado declara que tomou ciência das referidas condições contratuais.
        </p>

        <h2>4. REGISTRO DO PRODUTO</h2>
        <p>
            4.1. O registro do produto é automático e não representa aprovação ou recomendação por parte da Superintendência de Seguros Privados (Susep).
        </p>

        <h2>5. CONSULTA CADASTRAL</h2>
        <p>
            5.1. Quando aplicável, o segurado poderá consultar a situação cadastral do corretor de seguros e da sociedade seguradora no sítio eletrônico <a href="https://www.susep.gov.br" target="_blank">www.susep.gov.br</a>.
        </p>

        <h2>6. REMUNERAÇÃO DO REPRESENTANTE:</h2>
        <p>
            6.1. O percentual de remuneração do Intermediário pela intermediação do contrato de Seguro é de 65% (sessenta e cinco por cento).
        </p>

        <h2>7. DECLARAÇÕES INEXATAS</h2>
        <p>
            7.1. O proponente/segurado declara que goza de plena saúde, não possuindo lesões ou doenças preexistentes à contratação do seguro.
        </p>
        <p>
            7.2. Se o segurado, por si ou por seu representante, fizer declarações inexatas ou omitir circunstâncias que possam influir na aceitação da proposta ou no valor do prêmio, perderá o direito à indenização, além de estar o segurado obrigado ao pagamento do prêmio vencido.
        </p>

        <h2>8. CONDIÇÃO DE SANCIONADO</h2>
        <p>
            8.1. O Proponente/Segurado declara que não se enquadra e nunca se enquadrou na condição de réu ou investigado em qualquer processo relacionado à Fraudes, Crimes relacionados à Lavagem de Dinheiro, Terrorismo e crimes conexos a estes. Da mesma forma, declara ainda que não ocupa a condição de sancionado perante qualquer órgão nacional e internacional que atua na Prevenção à Lavagem de Dinheiro ou Combate ao Financiamento do Terrorismo. Para fins de exemplo de órgãos que atuam em tal seara, indicamos: Conselho de Controle de Atividades Financeiras (COAF), Grupo de Ação Financeira Internacional (GAFI), Organização das Nações Unidas (ONU).
        </p>
        <p>
            Na hipótese da Seguradora constatar, a qualquer tempo durante a vigência do seguro, que o Proponente/Segurado faltou com a verdade no que se refere a esta declaração, ou, ainda, após a contratação do seguro venha a se enquadrar nas hipóteses indicadas acima, expressamente autoriza a Seguradora a cancelar o Seguro.
        </p>

        <h2>9. AUTORIZAÇÃO PARA CANCELAMENTO DO SEGURO</h2>
        <p>
            9.1. O proponente autoriza expressamente a seguradora a cancelar o seguro em caso de fraudes ou caso o proponente venha a ter qualquer relação com crimes de Lavagem de Dinheiro e Financiamento do Terrorismo (PLD/FT).
        </p>

        <h2>10. ACEITAÇÃO DOS TERMOS</h2>
        <p>
            10.1. Ao adquirir qualquer produto ou serviço intermediado por nós, o cliente concorda com os termos e condições aqui estabelecidos, bem como com todas as legislações e regulamentações aplicáveis.
        </p>

        <h2>11. ALTERAÇÕES NOS TERMOS E CONDIÇÕES</h2>
        <p>
            11.1. Reservamo-nos o direito de alterar estes Termos e Condições a qualquer momento, mediante aviso prévio aos clientes.
        </p>

        <h2>12. CONTATO</h2>
        <p>
            12.1. Em caso de dúvidas ou informações adicionais sobre estes Termos e Condições, entre em contato conosco por meio dos canais de comunicação disponibilizados.
        </p>

        <p>
            Seguradora: 180 Seguros S.A., CNPJ: 39.999.619/0001-97, código SUSEP 04383, Processo SUSEP: 15414.609571/2024-03. Representante de Seguros: OPEN CO TECNOLOGIA S.A., CNPJ: 20.955.843/0001-59.
        </p>
        <p>Ouvidoria 180 Seguros S.A. Telefone: 0800 723 1454 E-mail: ouvidoria@180s.com.br</p>
        <p>Para mais informações consulte o nosso site <a href="https://www.180s.com.br/" target="_blank">https://www.180s.com.br/</a></p>
    </div>
);

export default InsuranceTermsText;
